import { NewsProvider } from './../../providers/news/news';
import { Category } from './../../models/News';
import { Component, Output, EventEmitter } from '@angular/core';

/**
 * Generated class for the NewsCategoriesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'news-categories',
  templateUrl: 'news-categories.html'
})
export class NewsCategoriesComponent {
  @Output('category') category: EventEmitter<Category> = new EventEmitter<Category>();
  constructor(public newsCtrl: NewsProvider) {
  }

  openCategory(category: Category){
    this.category.emit(category)
    this.newsCtrl.singleCategory = category;
  }

}



// WEBPACK FOOTER //
// ./src/components/news-categories/news-categories.ts